export default {

    data(){

        return {

            columnsModal    : false,
            filteredFields  : [],
            availableFields : [ 'override', 'me', 'to', 'make', 'sense' ]
        }
    },
    computed: {

        fields() {

            let fields = [];
            for( let field of this.availableFields ){

                if( this.filteredFields.indexOf( field ) !== -1 ){

                    fields.push({

                        'key'      : field,
                        'sortable' : [ 'EVV Message', 'Disputed', 'Time' ].includes( field ) ? false : true,
                    });
                }
            }
            fields.push( { key: 'flags', sortable: false } );
            fields.push( { key: 'actions', class: 'hidden-print' } );
            return fields;
        },
    },
    methods: {

        getLocalStorage( item ){

            let val = localStorage.getItem( 'shift_report_' + item );
            if( typeof( val ) === 'string' ){

                if( val.toLowerCase() === 'null' || val.toLowerCase() === '' ) return null;
                if( val.toLowerCase() === 'false' ) return false;
                if( val.toLowerCase() === 'true' ) return true;
            }
            return val;
        },

        setLocalStorage( item, value ){

            if( typeof( Storage ) !== "undefined" ) localStorage.setItem( 'shift_report_' + item, value );
        },
    },
    mounted(){

        this.setInitialFields();
    },
    watch: {

        filteredFields( val ){

            this.setLocalStorage( 'fields', JSON.stringify( val ) );
        },
        showSummary(val) {

            this.setLocalStorage('showSummary', JSON.stringify(val));
        },
        parent_carrier(val){

            console.log(val);
            this.setLocalStorage('filterParentCarrier', val);
        },
        caregiver_id( val ){

            this.setLocalStorage( 'filterCaregiverId', val );
        },
        client_id(val) {

            this.setLocalStorage('filterClientId', val);
            if (val) this.payment_method = ""; // Set payment method filter back to all if client is selected
        },
        flag_filter(val) {

            this.setLocalStorage('filterFlag', val);
        },
        carrier(val) {

            console.log(val);
            this.setLocalStorage('filterCarrier', val);
        },
        start_date(val) {

            this.setLocalStorage('startDate', val);
        },
        end_date(val) {

            this.setLocalStorage('endDate', val);
        },
    }
}